import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import Categories from "./pages/Categories";
import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import { NotificationProvider } from "./contexts/NotificationContext";
import { CourseProvider } from "./contexts/CourseContext";
import { CategoryProvider } from "./contexts/CategoryContext";
import { PartnerProvider } from "./contexts/PartnerContext";
import { EnrollmentProvider } from "./contexts/EnrollmentContext";
import Partners from "./pages/Partners";
import "./App.css";
import Enrollments from "./pages/Enrollments";
import Users from "./pages/Users";
import { UserProvider } from "./contexts/UserContext";

const App: React.FC = () => {
  return (
    <NotificationProvider>
      <CourseProvider>
        <CategoryProvider>
          <PartnerProvider>
            <EnrollmentProvider>
              <UserProvider>
                <Router>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                          <MainLayout>
                            <Dashboard />
                          </MainLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/courses"
                      element={
                        <ProtectedRoute>
                          <MainLayout>
                            <Courses />
                          </MainLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/categories"
                      element={
                        <ProtectedRoute>
                          <MainLayout>
                            <Categories />
                          </MainLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/partners"
                      element={
                        <ProtectedRoute>
                          <MainLayout>
                            <Partners />
                          </MainLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/enrollments"
                      element={
                        <ProtectedRoute>
                          <MainLayout>
                            <Enrollments />
                          </MainLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/users"
                      element={
                        <ProtectedRoute>
                          <MainLayout>
                            <Users />
                          </MainLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/"
                      element={<Navigate to="/login" replace />}
                    />
                  </Routes>
                </Router>
              </UserProvider>
            </EnrollmentProvider>
          </PartnerProvider>
        </CategoryProvider>
      </CourseProvider>
    </NotificationProvider>
  );
};

export default App;
